import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';

import { TfSearchFooterComponent } from './components/search-footer/search-footer.component';
import { TfButtonModule } from "@app/modules/tf-buttons";

@NgModule({
    declarations: [
        TfSearchFooterComponent
    ],
    imports: [
        CommonModule,
        TfButtonModule
    ],
    exports: [
        TfSearchFooterComponent
    ],
    providers: [DecimalPipe]
})
export class TfSearchFooterModule {
}
